import React from 'react';
import {CardElement} from '@stripe/react-stripe-js';

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      'color': localStorage.getItem("theme") == "dark"?"white":'#32325d',
      'backgroundColor': localStorage.getItem("theme") == "dark"?"#0f0f0f":"white",
      'fontFamily': '"Helvetica Neue", Helvetica, sans-serif',
      'fontSmoothing': 'antialiased',
      'fontSize': '16px',
      'border': '2px solid #efefef',
      '::placeholder': {
        color: '#aab7c4',
      },
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a',
    },
  },
  hidePostalCode: true
};

export default function CardInputElement() {
  return (
    <CardElement options={CARD_ELEMENT_OPTIONS}/>
  );
}
